import React from 'react';
import './MusicEventsInfo.scss';

type MusicEventsInfoProps = {
    ageRestriction: string | null;
    presenter: string | null;
};

export const MusicEventsInfo = (props: MusicEventsInfoProps) => {
    const itemList = Object.keys(props).map((itemKey, index) => {
        const item = props[itemKey as keyof MusicEventsInfoProps];

        if (item === null) return;

        return <li key={index}>{item}</li>;
    });

    return <ul className="music-event-info">{itemList}</ul>;
};
